import React from 'react'
import { Config } from '../helpers/Config';
import PropTypes from 'prop-types';

export const LanguageActive = (props) => {
    return (

        Config.languageList.filter(item => item.key === props.lang).map(item => {

                return (
                    <React.Fragment key={props.lang}>
                        <img src={"/assets/images/flags/" + item.icon} className="mr-2" height="16" alt="" /> {item.text}  &nbsp; <span className="mdi mdi-chevron-down"></span>
                    </React.Fragment>
                )
        })
    )
}

export const LanguageList = (props) => {
    return (
        Config.languageList.map(item => {
            return (
                <button type="button" key={item.key} className={"dropdown-item " + (props.lang === item.key ? 'active' : '')} onClick={(e) => props.handleClick(e, item.key)}><img src={"/assets/images/flags/" + item.icon} alt="" height="24" /><span> {item.text} </span></button>
            )
        })
    )
}

LanguageList.prototype={
    lang: PropTypes.bool 
}